<template>
    <BaseForm>
        <template #fields>
            <MultiLinkGroup>
                <MultiLink
                    :label="$t('fair-abroad')"
                    :links="values.fairAbroad"
                    :error-messages="errors.fairAbroad"
                    @input="setFieldValue('fairAbroad', $event)"
                    @delete="setFieldValue('fairAbroad', $event)"
                />
                <MultiLink
                    :label="$t('fair-abroad-cooperation')"
                    :links="values.fairAbroadCooperation"
                    :error-messages="errors.fairAbroadCooperation"
                    @input="setFieldValue('fairAbroadCooperation', $event)"
                    @delete="setFieldValue('fairAbroadCooperation', $event)"
                />
            </MultiLinkGroup>
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import MultiLinkGroup from '@/components/MultiLink/MultiLinkGroup.vue';
import { useEventSeriesInjection } from '@/event/composables/useEventSeriesInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventSeriesFairAbroadSchema } from '../schemas';

defineProps<{ seriesId: string }>();

const { series, createEventSeriesMultiLink } = useEventSeriesInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createEventSeriesMultiLink);

const fairAbroadId = computed(() => series.value?.fairAbroad?.id);
const fairAbroadCooperationId = computed(() => series.value?.fairAbroadCooperation?.id);

const fairAbroadLinks = computed(() => series.value?.fairAbroad?.links.nodes ?? []);
const fairAbroadCooperationLinks = computed(() => series.value?.fairAbroadCooperation?.links.nodes ?? []);

const { errors, values, setFieldValue, validate, onDiscard, resetForm } = useForm(
    EventSeriesFairAbroadSchema,
    computed(() => ({
        fairAbroad: getFormFieldLinks(fairAbroadLinks),
        fairAbroadCooperation: getFormFieldLinks(fairAbroadCooperationLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            { id: fairAbroadId.value, fieldName: 'fairAbroad', links: values.value.fairAbroad },
            {
                id: fairAbroadCooperationId.value,
                fieldName: 'fairAbroadCooperation',
                links: values.value.fairAbroadCooperation,
            },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
